import { render, staticRenderFns } from "./NcEditor.vue?vue&type=template&id=7cf9cae2&scoped=true&"
import script from "./NcEditor.vue?vue&type=script&lang=js&"
export * from "./NcEditor.vue?vue&type=script&lang=js&"
import style0 from "./NcEditor.vue?vue&type=style&index=0&id=7cf9cae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf9cae2",
  null
  
)

export default component.exports